import { connect } from 'react-redux'
import IconTile from './IconTile'

// The composer selection is updated in place, so read membership fresh on every store change
export default connect((store, { entity }) => {
	const open = store.iconDetail.icon
	const selected = store.iconstore.iconstore.selected_glyphs || []
	return {
		isActive: !!open && open.id === entity.id,
		inCollection: selected.includes(entity.id)
	}
})(IconTile)
